import { z } from 'zod'

export enum PrivacyField {
  FirstName = 'firstName',
  LastName = 'lastName',
  Uid = 'uid',
  Email = 'email',
  ResidencyCountry = 'residencyCountry',
  ResidencyState = 'residencyState',
  Telephone = 'telephoneNumber',
  PhysicalAddress = 'physicalAddress',
  RelatedServices = 'relatedServices',
  RequestDetail = 'requestDetail',
}

export const PrivacySchema = z.object({
  [PrivacyField.FirstName]: z.string().nonempty(),
  [PrivacyField.LastName]: z.string().nonempty(),
  [PrivacyField.Uid]: z.string().nonempty(),
  [PrivacyField.Email]: z.string().nonempty(),
  [PrivacyField.ResidencyCountry]: z.string().nonempty(),
  [PrivacyField.ResidencyState]: z.string().nonempty(),
  [PrivacyField.Telephone]: z.string().optional(),
  [PrivacyField.PhysicalAddress]: z.string().optional(),
  [PrivacyField.RelatedServices]: z.string().nonempty(),
  [PrivacyField.RequestDetail]: z.string().nonempty(),
})

export const PrivacyFormProps = new Map([
  [PrivacyField.FirstName, { label: 'First Name', required: true }],
  [PrivacyField.LastName, { label: 'Last Name', required: true }],
  [
    PrivacyField.Uid,
    { label: 'UID', required: true, description: 'Can be found and copied from your account profile' },
  ],
  [
    PrivacyField.Email,
    {
      label: 'Email',
      required: true,
      description: 'Please provide the email address associated with your game account',
    },
  ],
  [PrivacyField.ResidencyCountry, { label: 'Residency Country', required: true }],
  [PrivacyField.ResidencyState, { label: 'Residency State/Region', required: true }],
  [
    PrivacyField.Telephone,
    {
      label: 'Telephone Number',
      description:
        'This field is optional. However, providing the telephone number linked to your game account may help us verify your identity',
    },
  ],
  [
    PrivacyField.PhysicalAddress,
    {
      label: 'Physical Address',
      description:
        'This field is optional. However, providing the physical address linked to your game account may help us verify your identity',
    },
  ],
  [PrivacyField.RelatedServices, { label: 'Products/Services related to this Request', required: true }],
  [PrivacyField.RequestDetail, { label: 'Please provide more details about your request', required: true }],
])
